/* Components */
import Icon from 'Components/Icon';

const FormSelect = ({
	label,
	name,
	value,
	setValue,
	options,
	errors
}) => (
	<div className="form-select-component">
		<span className="buttonCaps label">{label}</span>
		<div className={`select-wrapper ${errors[name] ? 'error' : ''}`}>
			<select name={name} defaultValue={value} onChange={(e) => setValue(e.target.value)}>
				<option value="" disabled>Sélectionner...</option>
				{options.map(option => <option value={option.value} key={option.label}>{option.label}</option>)}
			</select>
			<Icon name="utilitary_downsm" isHM />
		</div>

		{errors[name] && (
			<span className="error-message bodyBullet">
				{errors[name].message}
			</span>
		)}
	</div>
);

FormSelect.propTypes = {
	label: PropTypes.string.isRequired,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	setValue: PropTypes.func.isRequired,
	name: PropTypes.string,
	options: PropTypes.arrayOf(PropTypes.shape({
		value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		label: PropTypes.string
	})).isRequired,
	errors: PropTypes.instanceOf(Object)
};

FormSelect.defaultProps = {
	name: null,
	value: null,
	errors: []
};

export default FormSelect;
